import { Component, OnInit } from '@angular/core';
import {FastLinkDataService} from "../fastlinkdataservice";
import {eFASTLINK_SUBCOMMAND, FASTLINKLCD} from "../fastlinkstruct";

@Component({
  selector: 'app-fast-link-lcd',
  templateUrl: './fast-link-lcd.component.html',
  styleUrls: ['./fast-link-lcd.component.css']
})
export class FastLinkLCDComponent implements OnInit {
  fastLinkLcd: FASTLINKLCD | undefined;
  readonly eFASTLINK_SUBCOMMAND: typeof eFASTLINK_SUBCOMMAND = eFASTLINK_SUBCOMMAND;

  constructor(private fastLinkDataService: FastLinkDataService) { }

  ngOnInit(): void {
    this.GetData(0);
  }

  OnKey(key: eFASTLINK_SUBCOMMAND) {
    this.GetData(key);
  }

  GetData(command: number) : void
  {
    this.fastLinkDataService.GetLCDData(command).subscribe({
      next: fastLinkLcd => {
        this.fastLinkLcd = fastLinkLcd;
      }
    });
  }

}
